import React, { useState } from 'react';
import './Aboutus.css';
import aboutUsSectionImg1 from '../../assets/aboutUsSectionImg1.webp';
import Gettouch from '../../components/getTouch/Gettouch';
import { Link } from 'react-router-dom';

const AboutUs = () => {

        const [selectedYear, setSelectedYear] = useState('1980');

        const yearContent = {
                '1980': {
                        heading: 'Foundation & Footing',
                        text: <p>
                                Chemi-Salt Corporation was founded in 1980 by <strong>Mr. Pravin P. Bhayani</strong>, and by 1985, it had established itself as a dependable source of industrial salt in South Gujarat. Operating with limited resources but unwavering commitment, Mr. Bhayani built lasting relationships with local industries. These years laid the foundation of the company’s core values: <strong>quality, integrity, and trust</strong>.
                        </p>,
                },
                '1995': {
                        heading: 'Diversification & Growth',
                        text: <p>
                                As demand grew, Chemi-Salt expanded its portfolio to include <strong>minerals and basic industrial chemicals</strong>, becoming a one-stop solution for multiple industries. The company began building partnerships beyond Valsad and Pardi, slowly extending into surrounding regions. By the early 2000s, Chemi-Salt was recognized for its <strong>reliable supply, transparent dealings, and personalized service</strong>.

                        </p>,
                },

                '2005': {
                        heading: 'Modernization & Reputation',
                        text: <p>
                                With growing trust in the market, Chemi-Salt modernized its processes and strengthened logistics. Warehousing, packaging, and quality control were streamlined. The company built a reputation not just for being a supplier, but a <strong>trusted partner</strong> for long-term supply contracts. New customer segments, especially SMEs and manufacturers, started turning to Chemi-Salt for <strong>consistent quality at competitive prices</strong>.

                        </p>,
                },
                '2015': {
                        heading: 'Leadership Transition & Innovation',
                        text: <p>
                                This decade marked a new chapter. Leadership gracefully transitioned to the next generation: Mr. <strong>Alpesh Bhayani and Mr. Trupesh Bhayani</strong>, with <strong>Mrs. Rita Pravin Bhayani</strong> continuing to guide the vision. Under their management, Chemi-Salt embraced <strong>digital tools, customer-centric practices</strong>, and continued product diversification — while remaining rooted in the ethics established in 1980. Today, Chemi-Salt serves as a <strong>trusted dealer in Salt, Minerals, and Chemicals</strong>, known for value, reliability, and legacy.
                                
                                
                        </p>,
                },
                '2025': {
                        heading: 'Future Vision',
                        text: `Our vision is to foster long-term partnerships, promote sustainable practices, and contribute meaningfully to industrial growth in India and beyond.`,
                },
        };





        return (
                <div className="About-Us-Main-Container">
                        <div className='About-Us-Container-1'>


                                <h4 className='About-Chemi-Heading-Text'>Chemi-Salt Corporation</h4>
                                <p className='About-Chemi-Content-Text'>
                                        Chemi-Salt Corporation is a trusted name in the Salt, Mineral, and Chemical industry, proudly serving the South Gujarat region since 1980. Founded by Mr. Pravin P. Bhayani, the company was built on the values of quality, integrity, and long-term partnerships.
                                </p>
                                <p className='About-Chemi-Content-Text'>With over four decades of industry experience, we have earned a reputation for delivering high-purity products at competitive prices — making us the best value dealers in the region.</p>
                                <p className='About-Chemi-Content-Text'>Today, under the leadership of Mrs. Rita Pravin Bhayani and actively managed by the next generation, Mr. Alpesh Bhayani and Mr. Trupesh Bhayani, Chemi-Salt continues to evolve, innovate, and grow — while staying rooted in the principles that define us.</p>
                        </div>
                        <div className='About-Us-Our-Story-Container'>
                                <h1>Our Story</h1>
                                <div className='About-Years-Row-Align-Container'>
                                        {Object.keys(yearContent).map((year) => (
                                                <h1
                                                        key={year}
                                                        className={selectedYear === year ? 'active-year' : ''}
                                                        onClick={() => setSelectedYear(year)}
                                                        style={{ cursor: 'pointer' }}
                                                >
                                                        {year}
                                                </h1>
                                        ))}
                                </div>

                                <div className='About-Years-Card-box'>
                                        <img src={aboutUsSectionImg1} alt='aboutUsSectionImg' className='About-Years-Card-Img' />
                                        <div className='About-Years-Card-Text'>
                                                <h1>{yearContent[selectedYear].heading}</h1>
                                                <p>{yearContent[selectedYear].text}</p>
                                        </div>
                                </div>
                        </div>

                        <div className='About-Vision-Mission-Main-Container'>

                                <div className='About-Vision-Mission-Card-Box'>
                                        <h1>OUR VISION</h1>
                                        <p>
                                                At <strong>Chemi-Salt Corporation</strong>, our vision is to become a benchmark in the Salt, Mineral, and Chemical industry — not just through the quality of our products, but through the trust we build with every customer.
                                                <br /><br />
                                                We strive to lead with integrity, deliver consistent value, and evolve with innovation, while staying rooted in the principles that have guided us since 1980. Our vision is to foster long-term partnerships, promote sustainable practices, and contribute meaningfully to industrial growth in India and beyond.
                                                <br /><br />
                                                With a customer-centric approach and a commitment to excellence, we aim to be more than a supplier — we aim to be a trusted partner in progress.
                                        </p>
                                </div>


                                <div className='About-Vision-Mission-Card-Box'>
                                        <h1>OUR MISSION</h1>
                                        <p>
                                                At <strong>Chemi-Salt Corporation</strong>, our mission is to deliver high-quality salts, minerals, and chemicals that meet the evolving needs of industries across India and beyond.
                                                <br /><br />
                                                We are committed to maintaining the highest standards of product purity, reliability, and customer service. By fostering long-term relationships, embracing responsible practices, and continuously improving our processes, we aim to create lasting value for our clients, partners, and the communities we serve.
                                                <br /><br />
                                                Our mission is to be more than a supplier — to be a trusted partner in growth, innovation, and industrial progress.
                                        </p>
                                </div>


                        </div>


                        <section className="About-Why-Us-Section">
                                <h1 className="About-Why-Us-Heading">Why Choose Us</h1>
                                <p className="About-Why-Us-Description">
                                        At <span className="Home-Why-Us-Brand-Name">Chemicalist</span>, we blend science with innovation to craft cutting-edge chemical solutions that power industries worldwide.
                                        <br />Our mission is to revolutionize chemical manufacturing through sustainability, precision, and unmatched quality.
                                </p>
                                <div className="About-Why-Us-Cards-Container">
                                        <div className="About-Why-Us-Card">
                                                <h3>🌱 Sustainability</h3>
                                                <p>We prioritize eco-friendly solutions that support a cleaner, greener future.</p>
                                        </div>
                                        <div className="About-Why-Us-Card">
                                                <h3>🔬 Innovation</h3>
                                                <p>Driven by research and discovery, we push boundaries in chemical tech.</p>
                                        </div>
                                        <div className="About-Why-Us-Card">
                                                <h3>🤝 Integrity</h3>
                                                <p>We build strong partnerships through trust, transparency, and excellence.</p>
                                        </div>
                                </div>
                        </section>


                        <div className='About-We-Offer-Main-Container'>
                                <h1>What We Offer</h1>
                                <div className='About-We-Offer-Row-Align-Container'>
                                        <div className='About-We-Offer-Products-Types-Card'>
                                                <h2>SALTS</h2>
                                                <p>Our premium quality salts are perfect for culinary, industrial, and agricultural needs. We offer a variety of salts, each with specific applications and benefits.</p>
                                                <Link to="/salts" className='About-We-Offer-More-Btn'>Know More</Link>
                                        </div>
                                        <div className='About-We-Offer-Products-Types-Card'>
                                                <h2>MINERALS</h2>
                                                <p>We provide high-quality minerals for various industries, offering essential nutrients and compounds that support manufacturing and health sectors.</p>
                                                <Link to="/minerals" className='About-We-Offer-More-Btn'>Know More</Link>
                                        </div>
                                        <div className='About-We-Offer-Products-Types-Card'>
                                                <h2>CHEMICALS</h2>
                                                <p>Our chemicals are carefully sourced and processed for a wide range of industrial applications, ensuring efficiency, safety, and reliability in all uses.</p>
                                                <Link to="/chemicals" className='About-We-Offer-More-Btn'>Know More</Link>
                                        </div>
                                </div>

                        </div>



                        <Gettouch />
                </div>
        );
};

export default AboutUs;
